import type { WhitelabelVariantDefinition } from '../../types';

export const medialuoWhitelabel = {
  id: 'medialuo',
  colors: {
    primary: {
      900: '#002962',
      800: '#003A8C',
      700: '#096DD9',
      500: '#48ACFF',
      300: '#91D5FF',
      100: '#E6F7FF',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const medialuoDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: medialuoWhitelabel.colors.primary[900],
      dark: medialuoWhitelabel.colors.primary[800],
      main: medialuoWhitelabel.colors.primary[700],
      light: medialuoWhitelabel.colors.primary[500],
      lighter: medialuoWhitelabel.colors.primary[300],
      muted: medialuoWhitelabel.colors.primary[100],
      contrastText: medialuoWhitelabel.colors.primary.contrastText,
    },
  },
};
